
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import dynamic from 'next/dynamic';
import SEO from 'global/SEO';
import usePublicProtectedRoute from 'hooks/usePublicProtectedRoute';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import 'react-phone-input-2/lib/style.css';

const captchaSiteKey = process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_V3;
const Register = dynamic(() => import('features/register'));
const AuthLayout = dynamic(() => import('global/AuthLayout'));

function RegisterPage() {
  usePublicProtectedRoute();

  return (
    <AuthLayout>
      <SEO description="Registrasi untuk mulai investasi saham di aplikasi Stockbit." />
      <GoogleReCaptchaProvider reCaptchaKey={captchaSiteKey}>
        <Register />
      </GoogleReCaptchaProvider>
    </AuthLayout>
  );
}

export default RegisterPage;
